import { readRedirectUrlOnce } from "./authService";

const DEFAULT_ERROR_MESSAGE =
  "Fehler beim Anmelden. Bitte kontaktieren Sie Ihren Administrator.";

export const resolveLoginMessage = ({ error, response, fallback }) => {
  return (
    response?.data?.message ||
    error?.response?.data?.message ||
    fallback ||
    DEFAULT_ERROR_MESSAGE
  );
};

export const applyUserAfterLogin = ({ userContext, user, navigate }) => {
  if (userContext && typeof userContext.setUser === "function") {
    userContext.setUser(user);
  }

  const redirect_url = readRedirectUrlOnce();
  if (redirect_url) {
    navigate(redirect_url);
  } else {
    navigate("/home");
  }
};
